import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-block content-block--separated" }
const _hoisted_2 = { class: "work-step__img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "work-step__content" }
const _hoisted_5 = { class: "work-step__title" }
const _hoisted_6 = { class: "work-step__num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-6 text-center" }, " How it Works? ", -1)),
    _createVNode(_component_v_row, {
      wrap: "",
      class: "work-steps"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workSteps, (workStep, idx) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: idx,
            class: "d-flex",
            cols: "12",
            sm: "6"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["work-step elevation-2", {'active': idx === 0}])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: require(`@/assets/svg/workSteps/${workStep.icon}.svg`),
                    alt: ""
                  }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(workStep.title), 1),
                  _createElementVNode("p", null, _toDisplayString(workStep.text), 1)
                ]),
                _createElementVNode("div", _hoisted_6, " 0" + _toDisplayString(idx + 1), 1)
              ], 2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}